import { render, staticRenderFns } from "./NoteListItem.vue?vue&type=template&id=afce5ee4"
import script from "./NoteListItem.vue?vue&type=script&lang=js"
export * from "./NoteListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports